import React from "react";
import { SetStringState } from "./MarginInput";

function useMarginInputSelector(
  setMarginInput: SetStringState,
  setErrMessage: SetStringState,
  resetPDF: () => void
) {
  const handleMarginChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    const withDecimal = value.includes(".");

    if (withDecimal) {
      const decimalPlaces = value.split(".")[1].length;
      if (decimalPlaces > 3) return;
    }

    if (value.includes("-") || value.includes("+") || value.includes("e")) {
      setErrMessage("Please Enter a Positive Whole Number");
    } else {
      var marginI = parseInt(value);
      marginI > 99 && marginI
        ? setErrMessage("Must be between 0 and 99")
        : setErrMessage("");
    }

    setMarginInput(value);
    resetPDF()
  };

  return {
    handleMarginChange,
  };
}

export default useMarginInputSelector;
